import { defineComponent as _defineComponent } from 'vue';
import { onMounted, ref, watch } from "vue";
import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
export default /*#__PURE__*/ _defineComponent({
    __name: 'JobLock',
    setup(__props) {
        const jobLock = ref(false);
        const jobLockUpdating = ref(true);
        watch(jobLock, async (_newVal) => {
            jobLockUpdating.value = true;
            const { data, error } = await GalaxyApi().PUT("/api/job_lock", { body: { active: jobLock.value } });
            if (error) {
                rethrowSimple(error);
            }
            jobLock.value = data.active;
            jobLockUpdating.value = false;
        });
        onMounted(async () => {
            const { data, error } = await GalaxyApi().GET("/api/job_lock");
            if (error) {
                rethrowSimple(error);
            }
            jobLock.value = data.active;
            jobLockUpdating.value = false;
        });
        return { __sfc: true, jobLock, jobLockUpdating };
    }
});
